export enum SmsSendTimeType {
  PREFERRED_BY_PARTICIPANT = 'preferred_by_participant',
  SPECIFIC_TIME = 'specific_time',
  TIME_RANGE = 'time_range',
}
